export interface SnackbarInterface {
  showAndDismiss: (ops: any) => void;
}

export const DISMISS_TIMEOUT = 2500;
export const LONG_DISMISS_TIMEOUT = 5000;
